import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-pa-others-support-doc',
    templateUrl: './pa-others-support-doc.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaOthersSupportDocComponent implements OnInit {
  public showAddDoc = false;
  constructor() { }

  ngOnInit() {
  }

}
